export default "__VITE_ASSET__C3hpwPC3__"